var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout-footer',{staticStyle:{"text-align":"center"}},[_vm._v("Created by Seadragon")])
}
var staticRenderFns = []

export { render, staticRenderFns }